import { Paper, Text } from '@mantine/core'
import type { ReactNode } from 'react'

type EmptyStateProps = {
  children: ReactNode
}

export default function EmptyState({ children }: EmptyStateProps) {
  return (
    <Paper p="xl">
      <Text c="dimmed" ta="center">
        {children}
      </Text>
    </Paper>
  )
}
